module.exports = {
  ATHENA_RD_GROUP_VISIT_FIELD: 'RD Group Visit',
  ATHENA_REFUSING_RD_FIELD: 'Refusing RD Appts',
};
